import React from "react";

const STATUS_COLORS = {
  // Tenant lifecycle statuses
  Active: { bg: "#D5F5E3", text: "#0B6E4F", dot: "#17A589", border: "transparent" },
  active: { bg: "#D5F5E3", text: "#0B6E4F", dot: "#17A589", border: "transparent" },
  Suspended: { bg: "#FDEBD0", text: "#784212", dot: "#E67E22", border: "transparent" },
  suspended: { bg: "#FDEBD0", text: "#784212", dot: "#E67E22", border: "transparent" },
  Trial: { bg: "#EBF5FB", text: "#154360", dot: "#2E86AB", border: "transparent" },
  trial: { bg: "#EBF5FB", text: "#154360", dot: "#2E86AB", border: "transparent" },
  Provisioning: { bg: "#F4ECF7", text: "#512E5F", dot: "#8E44AD", border: "transparent" },
  provisioning: { bg: "#F4ECF7", text: "#512E5F", dot: "#8E44AD", border: "transparent" },
  Offboarding: { bg: "#FADBD8", text: "#922B21", dot: "#C0392B", border: "transparent" },
  offboarding: { bg: "#FADBD8", text: "#922B21", dot: "#C0392B", border: "transparent" },
  Archived: { bg: "#F2F3F4", text: "#5D6D7E", dot: "#95A5A6", border: "transparent" },
  archived: { bg: "#F2F3F4", text: "#5D6D7E", dot: "#95A5A6", border: "transparent" },
  Maintenance: { bg: "#FDEBD0", text: "#784212", dot: "#E67E22", border: "transparent" },
  maintenance: { bg: "#FDEBD0", text: "#784212", dot: "#E67E22", border: "transparent" },
  // Infrastructure health statuses (from health matrix API)
  HEALTHY: { bg: "#D5F5E3", text: "#0B6E4F", dot: "#17A589", border: "transparent" },
  healthy: { bg: "#D5F5E3", text: "#0B6E4F", dot: "#17A589", border: "transparent" },
  DEGRADED: { bg: "#E0F7FA", text: "#006B7A", dot: "#00ACC4", border: "transparent" },
  degraded: { bg: "#E0F7FA", text: "#006B7A", dot: "#00ACC4", border: "transparent" },
  // UNHEALTHY: soft peach — noticeable but not alarming
  UNHEALTHY: { bg: "#FEF0E6", text: "#A0522D", dot: "#E8935A", border: "#F5C9A0" },
  unhealthy: { bg: "#FEF0E6", text: "#A0522D", dot: "#E8935A", border: "#F5C9A0" },
  UNKNOWN: { bg: "#F2F3F4", text: "#5D6D7E", dot: "#95A5A6", border: "transparent" },
  unknown: { bg: "#F2F3F4", text: "#5D6D7E", dot: "#95A5A6", border: "transparent" },
};

function StatusChip({ status }) {
  const c = STATUS_COLORS[status] || STATUS_COLORS.Active;
  const label = (status || "").charAt(0).toUpperCase() + (status || "").slice(1).toLowerCase();

  return (
    <span
      style={{
        background: c.bg,
        color: c.text,
        border: `1px solid ${c.border}`,
        padding: "3px 10px",
        borderRadius: 20,
        fontSize: 12,
        fontWeight: 600,
        display: "inline-flex",
        alignItems: "center",
        gap: 5,
        whiteSpace: "nowrap",
      }}
    >
      <span
        style={{
          width: 7,
          height: 7,
          borderRadius: "50%",
          background: c.dot,
          display: "inline-block",
        }}
      />
      {label}
    </span>
  );
}

export default StatusChip;
